export enum SelectedSchool {
  matejki = 'Matejki',
  krakowska = 'Krakowska'
}
